import { ConfiguratorBreakpoint } from '../types';
import { CONFIGURATOR_DEFAULT_LOCALE } from './locale';

export const CONFIGURATOR_PREVIEW_LOAD_BUFFER = 2 * 1000;

export const CONFIGURATOR_DESKTOP_BREAKPOINT: ConfiguratorBreakpoint = {
  id: 'desktop',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Desktop',
  },
  className: 'breakpoint-desktop',
};

export const CONFIGURATOR_TABLET_BREAKPOINT: ConfiguratorBreakpoint = {
  id: 'tablet',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Tablet',
  },
  className: 'breakpoint-tablet',
};

export const CONFIGURATOR_SMARTPHONE_BREAKPOINT: ConfiguratorBreakpoint = {
  id: 'smartphone',
  name: {
    [CONFIGURATOR_DEFAULT_LOCALE]: 'Mobile',
  },
  className: 'breakpoint-smartphone',
};

export const CONFIGURATOR_BREAKPOINTS: ConfiguratorBreakpoint[] = [
  CONFIGURATOR_SMARTPHONE_BREAKPOINT,
  CONFIGURATOR_DESKTOP_BREAKPOINT,
];

// Must match the mobile layout breakpoint used in the templates
// (`@media (min-width: 769px) { display: none }`), otherwise between 481–768px the
// mobile layout renders while isMobile is false (e.g. the mobile-only Basic package
// gets filtered out of the market-scan list).
export const CONFIGURATOR_MOBILE_MEDIA_QUERY = '(max-width: 768px)';
